import {
    Key
} from "../libs/Key";
import {
    B2dEditor
} from "./b2Editor/B2dEditor";
import * as PIXI from 'pixi.js'
import {
    ui
} from "./ui/UIManager";
import {
    backendManager
} from "./utils/BackendManager";
import {
    LoadCoreAssets, ExtractTextureAssets
} from "./AssetList";
import {
    Settings
} from "./Settings";
import {
    levelsData
} from "./data/levelsData";
import {MidiPlayer} from './utils/MidiPlayer'

import { timeFormat, JSONStringify } from "./b2Editor/utils/formatString";

import * as emitterManager from './utils/EmitterManager';
import * as PhysicsParticleEmitter from './utils/PhysicsParticleEmitter';
import { warmGore } from './utils/gore/goreChunks';
import * as SaveManager from "./utils/SaveManager";
import {isPokiHost, resolveDisableVocals} from "./utils/platformDefaults";
import * as PIXICuller from "./utils/PIXICuller";
import { limitTextResolution } from "./utils/pixiText";
import * as EffectsComposer from './utils/EffectsComposer';
import * as ExplosionManager from './utils/ExplosionManager';
import * as BreakableManager from './utils/BreakableManager';
import * as MobileController from './utils/MobileController';
import * as AudioManager from './utils/AudioManager';
import * as TutorialManager from './utils/TutorialManager';
import * as SlowmoUI from './ui/Slomo';
import * as GameTimer from './utils/GameTimer'
import { input } from './input/InputManager';
import { GameplaySession } from './utils/GameplaySession';
import { LevelSession } from './utils/LevelSession';
import { menuNavigation } from './ui/menuNavigation';
import * as ReplayManager from './utils/ReplayManager';
import * as replayControls from './ui/ReplayControls';
import { showXPGain } from './ui/XPToast';
import { simulationTime } from './utils/SimulationClock';
import * as b2DebugDrawManager from './utils/b2DebugDrawManager'
import * as BodyBreaker from './b2Editor/utils/bodyBreaker'
import * as ModManager from './utils/ModManager'

import { Camera as PIXICamera } from './utils/PIXICameraV6';
import { YouTubePlayer } from "./utils/YouTubePlayer";

import nanoid from 'nanoid';

import GameStats from 'gamestats.js'; //TO DO PUBLISH NPM
import { countries } from "./utils/Localization";


import {b2LinearStiffness, b2MulVec2} from '../libs/debugdraw'
import * as betterLocalStorage from './utils/LocalStorageWrapper'
import { updateDisplayAds } from "./utils/AdManager";
import { setZoom } from "./b2Editor/utils/camera";
import { localMultiplayer } from './multiplayer/localConfig';
import { autoConnectLobby, startMultiplayer, updateMultiplayer, multiplayerState, sendLevelWon, LOBBY_STATE, sendGameOver, sendCheckpoint, leaveMultiplayer } from "./multiplayer/multiplayerManager";
import { hudState, HUD_STATES, updateMultiplayerHud } from "./multiplayer/hud";
import FontFaceObserver from "fontfaceobserver";
import { updateBackground } from "./utils/BackgroundManager";
import * as ExplosionEffects from "./utils/ExplosionEffects";
import { drawHeldFrame, holdFrame, resetHitstop } from "./utils/Hitstop";
import {shouldDisablePortalContact} from './prefabs/guns/PortalBridge';
import {isLevelCompatible, LEVEL_VERSION_ERROR} from './utils/levelCompatibility';
import { recordReplayEvent, replayExport } from './utils/ReplayExportJob';
const {getPointer, NULL, JSQueryCallback, JSContactListener} = Box2D;

const {b2Vec2, b2AABB, b2Body, b2World, b2MouseJointDef} = Box2D;
const box2DWorldClasses = Object.keys(Box2D).filter(name => /^b2\w*(Body|Fixture|Joint|Contact)$/.test(name));

// chech WebGL support
(function () {
    if(!document.createElement('canvas').getContext('webgl')) {
        alert("Jolly! What happened!? WebGL could not be initialized. Please free up GPU/CPU resources by closing tabs and other software. Click OK to retry.");
        window.location.reload();
    }
})();

const vec1 = new b2Vec2();

function Game() {

    this.editor;
    this.app;
    this.stage;
    this.myContainer;
    this.levelCamera;
    this.myEffectsContainer;
    this.traceImage;
    this.newDebugGraphic;
    this.canvas;
    this.renderer;
    this.world;
    this.worldJSON;
    this.slowmoUI;
    this.slowmoUI_Text;

    this.selectedBody;
    this.mouseJoint;
    this.run = false;
    this.pause = false;
    this.gameState = false;

    this.playerPrefabObject;
    this.character;
    this.vehicle;
    this.desiredVehicleSpeed = 0;
    this.desiredVehicleTorque = 0;

    this.cameraFocusObject;
    this.lastKnownCameraPoint;
    this.cameraFocusCharacterObject;

    this.stats;

    this.currentLevelData;

    this.levelStartTime = 0;
    this.gameFrame = 0;
    this.levelWon = false;
    this.gameOver = false;
    this.checkPointData = null;
    this.selectedCharacter = 0;
    this.selectedMask = 0;
    this.selectedVehicle = 0;
    this.playedFirstLevel = false;
    this.gameplaySession = new GameplaySession();
    this.levelSession = new LevelSession((levelId, session) => backendManager.reportLevelSession(levelId, session));

    this.needScreenshot = false;
    this.screenShotData = null;

    this.ui = ui;

    this.preloader = document.getElementById('preloader');
    this.tutorialMode = false;
    this.showLevelAfterTutorial = null;
    this.lastPressedKeys = '';

    // path pixi for camera support
    // PathRenderTarget();

    this.getRenderResolution = () => Settings.HD && !replayExport
        ? Math.min(2, Math.max(1, window.devicePixelRatio || 1))
        : 1;

    this.gameInit = async function () {
        this.stats = new GameStats()
        document.body.appendChild(this.stats.dom);
        this.stats.dom.style.left = '0px';
        this.stats.dom.style.top = 'unset';
        this.stats.dom.style.bottom = '0px';
        this.stats.dom.style.zIndex = '999';
        const showStats = (window.location.search.indexOf('stats=true')>=0)
        this.stats.show(showStats);

        Settings.levelAdmin = window.location.search.indexOf('levelAdmin=true')>=0;

        this.canvas = document.getElementById("canvas");

        // platformDefaults detects Poki when it loads, before any module reads
        // the save, so fresh saves and locked settings follow the platform.
        Settings.onPoki = isPokiHost();

        const userData = SaveManager.getLocalUserdata();


        if(userData.country === '?'){
            let country = 'us';
            let userLang = navigator.language || navigator.userLanguage;
            if(userLang){
                const userCountry = userLang.split('-')[0];
                if(userCountry){
                    let userCountryLC = userCountry.toLowerCase();

                    if(userCountryLC === 'en'){
                        userCountryLC = 'us';
                    }

                    if(userCountryLC === 'cs'){
                        userCountryLC = 'cz';
                    }

                    if(userCountryLC === 'ja'){
                        userCountryLC = 'jp';
                    }

                    countries.forEach(c => {
                        if(c === userCountryLC){
                            country = c;
                        }
                    });
                }
            }

            userData.country = country;
            SaveManager.updateLocalUserData(userData);
        }
        Settings.currentCountry = userData.country;


        Settings.HD = userData.hdOn;
        Settings.pixelRatio = this.getRenderResolution();
        Settings.sfxOn = userData.sfxOn || !!replayExport;
        Settings.disableVocals = resolveDisableVocals(userData.disableVocals);
        Settings.bloodEnabled = userData.bloodOn;
        // Gore is always on; the blood toggle only picks normal or rainbow blood.
        Settings.goreEnabled = true;

        // Filters follow the current render target, including live HD changes.
        // A fixed 1x filter would downsample the scene during screen effects.
        PIXI.Filter.defaultOptions.resolution = 'inherit';
        this.app = new PIXI.Application();
        await this.app.init({
            canvas: this.canvas,
            preference: 'webgl',
            backgroundColor: 0xD4D4D4,
            resolution: Settings.pixelRatio,
            preserveDrawingBuffer: !!replayExport,
            // the game handles all input through its own DOM listeners
            eventFeatures: { move: false, globalMove: false, click: false, wheel: false },
        });
        limitTextResolution(this.app.renderer);

        this.app.canvas.addEventListener('webglcontextlost', _event => {
            this.IS_ERROR = true;
            alert("Jolly Goodness! I almost fried your PC, Sorry.. (kidding) Something stressed out the browser and I'm forced to restart the game! Click OK to restart.");
            window.location.reload();
        });

        window.__pixiScreenshot = ()=>{
            this.needScreenshot = true;
            return new Promise((resolve, _reject) => {
                let interval = setInterval(()=>{
                    if(this.screenShotData){
                        clearInterval(interval);
                        resolve(this.screenShotData);
                        this.needScreenshot = false;
                        this.screenShotData = null;
                    }
                }, 1)
            });
        }

        this.app.stop(); // do custom render step
        this.stage = this.app.stage;

        PIXI.Ticker.shared.stop();

        this.stage.interactiveChildren=false;

        this.editor = B2dEditor;

        LoadCoreAssets(progress => {
            const startProgress = 0.8;
            const leftProgress = 1.0-startProgress;
            window.setLoaderProgress(startProgress + leftProgress * progress);
        }).then(async () => {
            await ExtractTextureAssets();
            window.setLoaderProgress(1.0);
            PokiSDK.gameLoadingFinished();
            this.gameSetup();
        });

        this.prepareGameFonts();

        this.gameState = this.GAMESTATE_MENU;

        EffectsComposer.init(this.stage)
        // because a this.app.screen is object getter,
        // rectangle should updates automatically
        this.stage.filterArea = this.app.screen;

        if(MobileController.isMobile()) {
            MobileController.init();
        }

        YouTubePlayer.preload();
        TutorialManager.init();

    };

    this.gameSetup = async function () {
        // first thing we do is mod the textures
        await ModManager.installLinkedMod();
        await ModManager.init();

        this.world = new b2World(
            new b2Vec2(0, 10) //gravity
        );

        b2DebugDrawManager.init();

        const bodyDef = new Box2D.b2BodyDef();
        this.m_groundBody = this.world.CreateBody(bodyDef);

        //container
        this.myContainer = new PIXI.Container();

        this.levelCamera = new PIXICamera(this.myContainer);
        //this.levelCamera.disable();

        this.myContainer.camera = this.levelCamera;

        // inser rela camera to container, and now container broke transformation =)
        // render order:
        // stage (noraml update)
        //   => levelCamera_init_viewport
        //        => levelContaner (matix is shift it)
        //                => levelCamer_restore_viewport (normalUpdate)
        this.stage.addChild(this.levelCamera);

        //this.myContainer.addChild(this.levelContainer);


        //container
        this.myEffectsContainer = new PIXI.Container();
        this.stage.addChild(this.myEffectsContainer);

        this.hudContainer = new PIXI.Container();
        this.stage.addChild(this.hudContainer);

        this.triggerDebugDraw = new PIXI.Graphics();
        this.triggerDebugDraw.debounceRedraw = ()=>{
            while(game.triggerDebugDraw.children.length > 0){
                const child = game.triggerDebugDraw.getChildAt(0);
                child.destroy(true);
            }
            game.triggerDebugDraw.clear();
            this.triggerDebugDraw.redrawTimer = 6;
        }
        this.stage.addChild(this.triggerDebugDraw);

        this.newDebugGraphics = new PIXI.Graphics();

        this.gameRender();

        const res = alias => PIXI.Assets.get(alias);
        const assets = this.editor.assetLists;

        assets.characters = Object.keys(res("Characters_1.json").textures);
        assets.vehicles = [].concat(Object.keys(res("Vehicles_1.json").textures), Object.keys(res("Mech.json").textures));
        assets.movement = Object.keys(res("Movement.json").textures);
        assets.construction = Object.keys(res("Construction.json").textures);
        assets.nature = Object.keys(res("Nature.json").textures);
        assets.weapons = Object.keys(res("Weapons.json").textures);
        assets.level = Object.keys(res("Level.json").textures);
        assets.gore = Object.keys(res("Characters_Gore.json").textures);
        assets.misc = Object.keys(res("Misc.json").textures);
        warmGore();

        this.editor.tileLists = Settings.textureNames;
        this.editor.init(this.stage, this.myContainer, this.world, Settings.PTM);
        this.myContainer.addChild(this.newDebugGraphics);

        this.editor.contactCallBackListener = this.gameContactListener;



        const urlParams = new URLSearchParams(window.location.search);
        const forceTutorial = urlParams.get('forceTutorial');
        const previewQA = urlParams.get('previewQA');
        let uidHash = PokiSDK.getURLParam('lvl');
        const replayLink = PokiSDK.getURLParam('replay');
        const username = urlParams.get('user');
        const lobbyID = PokiSDK.getURLParam('lobbyID');

        if(!uidHash) uidHash = location.hash.split('/')[0].substr(1);
        const levelLink = uidHash && uidHash.length === 21;

        const userData = SaveManager.getLocalUserdata();
        if(previewQA || localMultiplayer) userData.tutorialFinished = true;
        game.selectedCharacter = userData.selectedCharacter;
        game.selectedMask = userData.selectedMask;

        if(
            window.dafadfgjiwrgj ||
            window.__jollyDisablePoki ||
            urlParams.get('disableAds') ||
            urlParams.get('disablePoki') ||
            previewQA
        ) Settings.disableAds = true;

        this.openMainMenu();

        if(__LOCAL_MULTIPLAYER__ && localMultiplayer){
            (await import('./multiplayer/localLab')).startLocalLab();
        }else if(urlParams.get('portalLab') === '1'){
            await this.openEditor(true);
        }else if(replayExport){
            import('./utils/ReplayExport').then(({runReplayExport}) => runReplayExport(this));
        }else if(replayLink){
            this.openReplayLink(replayLink);
        }else if(levelLink){
            this.openSinglePlayer();
            backendManager.getPublishedLevelInfo(uidHash).then(levelData => {
                ui.showLevelBanner(levelData);
                this.showLevelAfterTutorial = levelData;
            }).catch(_err =>{
                if(!Settings.onPoki) history.replaceState({}, document.title, '')
            });
        }else if(username){
            this.openSinglePlayer();
            ui.showUserPage(username);
        }else if(lobbyID){
            // start network manager

            // we need the single player menu build for recommendations
            ui.showSinglePlayer();
            ui.hideSinglePlayer();
		    ui.setMainMenuActive('lobby');
            startMultiplayer();
            autoConnectLobby(lobbyID);
        }
        this.gameplaySession.listen(document);
        this.levelSession.listen(document, window);
        input.mobile = MobileController.isMobile();
        document.body.addEventListener("keydown", this.onKeyDown.bind(this), {passive:false});
        document.body.addEventListener("keyup", this.onKeyUp.bind(this), {passive:false});
        this.canvas.addEventListener("mousedown", this.onMouseDown.bind(this), {passive:false});
        this.canvas.addEventListener("touchstart", this.onMouseDown.bind(this), {passive:false});
        document.addEventListener("mouseup", this.onMouseUp.bind(this), {passive:false});
        document.addEventListener("touchend", this.onMouseUp.bind(this), {passive:false});
        input.onReset = () => {
            MobileController.releaseTouches();
            input.syncEditorModifiers(this.editor);
        };
        const resetInput = () => input.reset();
        this.canvas.addEventListener("blur", resetInput);
        window.addEventListener("blur", resetInput);
        document.addEventListener('visibilitychange', () => { if(document.hidden) resetInput(); });
        document.addEventListener('focusin', event => {
            if(event.target !== this.canvas && event.target !== document.body) resetInput();
        });


        document.addEventListener("mouseup", ()=>{
            if(this.editor.editing) this.editor.storeUndoMovementDebounced();
        }, {passive:false});

        document.addEventListener("touchend", ()=>{
            if(this.editor.editing) this.editor.storeUndoMovementDebounced();
        }, {passive:false});


        document.addEventListener("mousemove", this.onMouseMove.bind(this), {passive:false});
        document.addEventListener("touchmove", this.onMouseMove.bind(this), {passive:false});
        document.addEventListener("pointermove", event => input.addPointerMovement(event), {passive:true});

        document.addEventListener("mousemove", this.onDocumentMouseMove.bind(this), {passive:false});
        document.addEventListener("touchmove", this.onDocumentMouseMove.bind(this), {passive:false});

        window.addEventListener('wheel', this.onMouseWheel.bind(this), {passive:false});
        window.addEventListener('resize', this.handleResize.bind(this));

        window.onbeforeunload = function(e) {
            if(this.editor.editing && window.location.href.indexOf('localhost:') < 0){
                const dialogText = 'Are you sure you want to close the editor?';
                e.returnValue = dialogText;
                return dialogText;
            };
        };

        if(MobileController.isMobile() && MobileController.isIos()){
            // ios reflow fix
            setInterval(()=>{
                this.handleResize();
            }, Settings.iosReflowInterval);
        }

        window.addEventListener('paste', (e)=> {
            if(input.blocked || !this.editor.editing || this.run || ![document.body, this.canvas].includes(document.activeElement)) return;
            if(this.editor.shiftDown) return;
            try{
            if(e.clipboardData == false) return false;
            [...e.clipboardData.items].forEach( el => {
                if(el.type == 'text/plain'){
                el.getAsString(s=>{
                        s = s.trim();
                        if(s && s.startsWith(Settings.jollyDataPrefix) && s.endsWith('>')){
                            const copyData = s.substr(Settings.jollyDataPrefix.length, s.length-Settings.jollyDataPrefix.length-1);
                            this.editor.pasteData(copyData);
                        }
                    });
                }else if(el.type.indexOf("image")>=0){
                    const imageFile =  el.getAsFile();
                    const src = URL.createObjectURL(imageFile);
                    // v8 Texture.from no longer fetches URLs; load the image first
                    const pastedImage = new Image();
                    pastedImage.src = src;
                    pastedImage.addEventListener('load', ()=> {

                        if(game.editor.tracingTexture){
                            game.editor.tracingTexture.destroy({texture:true, textureSource:true});
                        }

                        const texture = PIXI.Texture.from(pastedImage);
                        texture.source.scaleMode = 'nearest';
                        game.editor.tracingTexture = new PIXI.Sprite(texture);
                        game.editor.tracingTexture.pivot.set(game.editor.tracingTexture.width/2, game.editor.tracingTexture.height/2);
                        game.editor.container.addChildAt(game.editor.tracingTexture, 0);
                        if(game.editor.selectedTool === game.editor.tool_SETTINGS){
                            game.editor.selectedTool = -1;
                            game.editor.selectTool(game.editor.tool_SETTINGS);
                        }
                        game.editor.camera.set({ x:window.innerWidth/2, y:window.innerHeight/2 });
                    });
                }
            })
            }catch(e){
                console.log("Copy Paste error:", e);
            }
        })

        window.addEventListener('focus', ()=>{
            backendManager.backendLogin();
        })
        backendManager.registerListener('xp', ({gained, standing}) => showXPGain(gained, standing, backendManager.needsDiscordJoin() ? () => ui.joinDiscord() : null));

        emitterManager.init();
        ExplosionEffects.init();
        PhysicsParticleEmitter.init();

        PIXICuller.init(this.editor.textures, this.levelCamera);

        // enable jolly in iframe rendering when everything is loaded
        this.editor.initRenderJollyRendering();

        SlowmoUI.init();
        this.handleResize();
        AudioManager.init(); // Start core audio after textures and scene setup.

        if((!userData.tutorialFinished && !backendManager.isLoggedIn() && !MobileController.isMobile() && !lobbyID && !replayLink && !levelLink && !replayExport) || forceTutorial){
            this.showInitialTutorial();
        }else{
            this.preloader.classList.add('hide');
            this.preloader.querySelector('.cycling').classList.add('fall');
            delete this.showLevelAfterTutorial;
        }
    }

    this.showInitialTutorial = ()=>{
        const tutorialLevel = {...levelsData.tutorialLevel}
        game.loadPublishedLevelData(tutorialLevel, ()=>{}).then(() => {
            this.tutorialMode = true;
            ui.showSkipTutorialButton();
            ui.hideMainMenu();
            ui.playLevelFromSinglePlayer();
            this.preloader.querySelector('.cycling').classList.add('fall');
            ui.hideLevelBanner();
        }).catch(error => {
            // skip tutorial
            this.preloader.classList.add('hide');
        });
    }


    //mouse
    this.onMouseDown = function (e) {

        this.fixTouchEvent(e);

        if (Settings.allowMouseMovement && this.gameState == this.GAMESTATE_EDITOR && this.editor.editorSettingsObject.physicsDebug &&  !this.mouseJoint && this.run) {
            const body = this.getBodyAtMouse();
            if (body && body.mySprite && body.mySprite.data.type != this.editor.object_TRIGGER) {
                const md = new b2MouseJointDef();
                md.set_bodyA(this.m_groundBody);
                md.set_bodyB(body);
                const targetPosition = vec1;
                vec1.Set(this.editor.mousePosWorld.get_x(), this.editor.mousePosWorld.get_y());


                md.set_target(targetPosition);
                md.set_collideConnected(true);
                md.set_maxForce(300.0 * body.GetMass());

                b2LinearStiffness(md, 5.0, 0.7, this.m_groundBody, body);

                this.mouseJoint = this.editor.CreateJoint(md);

                body.SetAwake(true);

                Box2D.destroy(md);
            }
        }
        Key.onMouseDown(e);
        this.onMouseMove(e);
        if(this.gameState == this.GAMESTATE_EDITOR) this.editor.onMouseDown(e);
    };

    this.onMouseUp = function (e) {
        this.fixTouchEvent(e);
        Key.onMouseUp(e);
        this.editor.onMouseUp(e);
    };

    this.onMouseWheel = function(e){
        if(this.gameState == this.GAMESTATE_EDITOR) this.editor.onMouseWheel(e);
        if(e.target === this.canvas) e.preventDefault(); // no zooming on the canvas
    }

    this.onMouseMove = function (e) {
        this.fixTouchEvent(e);
        this.editor.onMouseMove(e);
    };
    this.onDocumentMouseMove = function (e) {
        this.fixTouchEvent(e);
        if(this.gameState == this.GAMESTATE_EDITOR) this.editor.onDocumentMouseMove(e);
    };
    this.fixTouchEvent = e => {
        if(e.changedTouches){
            const touch = e.changedTouches[0];
            e.clientX = touch.clientX;
            e.clientY = touch.clientY;
        }
    }

    this.handleResize = function (e) {
        const w = window.innerWidth;
        const h = window.innerHeight;
        const pixelRatio = this.getRenderResolution();

        if(w === this.oldInnerWidth && h === this.oldInnerHeight &&
            pixelRatio === this.app.renderer.resolution) return;

        Settings.pixelRatio = pixelRatio;
        this.canvas.style.width = `${w}px`;
        this.canvas.style.height = `${h}px`;
        this.app.renderer.resize(w, h, pixelRatio);

        PIXICuller.renderArea.width = w;
        PIXICuller.renderArea.height = h;

        const aspect = window.innerWidth/window.innerHeight;

        if(aspect<Settings.minimumAspect){
            Settings.aspectZoom = Math.min(window.innerWidth, window.innerHeight) / Settings.targetResolution.y;
        } else if(aspect>Settings.maximumAspect){
            const targetWidth = Settings.targetResolution.x;
            Settings.aspectZoom = window.innerWidth / targetWidth;
        }else{
            const targetWidth = Settings.targetResolution.x;
            Settings.aspectZoom = window.innerWidth / targetWidth;

            if(window.innerHeight / Settings.aspectZoom < Settings.targetResolution.y){
                const targetHeight = Settings.targetResolution.y
                Settings.aspectZoom = window.innerHeight / targetHeight;
            }
        }
        if(replayExport) Settings.aspectZoom *= replayExport.zoom;
        MobileController.resize();

        this.oldInnerWidth = window.innerWidth;
        this.oldInnerHeight = window.innerHeight;

        b2DebugDrawManager.resize();

        updateDisplayAds();
    }

    this.getBodyAtMouse = function () {
        var aabb = new b2AABB();
        aabb.get_lowerBound().Set(this.editor.mousePosWorld.get_x() - 0.001, this.editor.mousePosWorld.get_y() - 0.001);
        aabb.get_upperBound().Set(this.editor.mousePosWorld.get_x() + 0.001, this.editor.mousePosWorld.get_y() + 0.001);
        // Query the world for overlapping shapes.

        this.selectedBody = null;
        this.world.QueryAABB(this.getBodyCB, aabb);
        return this.selectedBody;
    };

    this.getBodyCB = new JSQueryCallback();
	this.getBodyCB.ReportFixture = function (fixturePtr) {
        const fixture = Box2D.wrapPointer( fixturePtr, Box2D.b2Fixture );
        if (fixture.GetBody().GetType() != Box2D.b2_staticBody && !fixture.GetBody().isPhysicsCamera &&
            !fixture.GetBody().isPortalGhost && !fixture.GetBody().isPortalShadow) {
            if (fixture.GetShape().TestPoint(fixture.GetBody().GetTransform(), self.editor.mousePosWorld)) {
                self.selectedBody = fixture.GetBody();
                return false;
            }
        }
        return true;
    }


    this.inputUpdate = function () {
        if (this.gameState != this.GAMESTATE_MENU && (this.character && this.character.alive) && !this.pause && !this.levelWon) {
            if (this.vehicle && !this.vehicle.destroyed && this.character.attachedToVehicle) {

                if (input.isDown('up')) {
                    this.vehicle.accelerate(1);
                };
                if (input.isDown('down')) {
                    this.vehicle.accelerate(-1);
                };
                if (!input.isDown('up') && !input.isDown('down')) {
                    this.vehicle.stopAccelerate();
                };

                if (input.isDown('left')) {
                    this.vehicle.lean(-1);
                    this.character.lean(-1);
                }
                if (input.isDown('right')) {
                    this.vehicle.lean(1);
                    this.character.lean(1);
                }
                // A vehicle that turns by steering jumps on flip too.
                this.vehicle.jump(input.isDown('jump') || Boolean(this.vehicle.flipJumps && input.isDown('flip')));
                // A vehicle that can grab holds on while grab is down.
                if (this.vehicle.grab) this.vehicle.grab(input.isDown('grab'));
                // A vehicle that can go limp holds it while eject is down instead of letting the rider go.
                if (this.vehicle.flop) this.vehicle.flop(input.isDown('eject'));
                else if (input.isPressed('eject')) {
                    this.character.detachFromVehicle(Settings.detachForce);
                };
                if(input.isPressed('flip') && !this.vehicle.flipJumps){
                    this.character.flipFromInput();
                }

            } else if (this.character && !this.character.destroyed && !this.character.attachedToVehicle) {
                if (input.isDown('up')) {
                    this.character.positionBody('up');
                    if (input.isDown('left')) this.character.lean(-1);
                    else if (input.isDown('right')) this.character.lean(1);
                } else if (input.isDown('down')) {
                    this.character.positionBody('down');
                    if (input.isDown('left')) this.character.lean(-1);
                    else if (input.isDown('right')) this.character.lean(1);
                } else if (input.isDown('left')) {
                    this.character.positionBody('left');
                    this.character.lean(-0.3);
                } else if (input.isDown('right')) {
                    this.character.positionBody('right');
                    this.character.lean(0.3);
                }

                if(input.isPressed('flip')){
                    this.character.flipFromInput();
                }

                if(input.isDown('grab')){
                    this.character.grab();
                }
                if(input.isReleased('grab')){
                    this.character.release();
                }
            }

            if(this.character.hat){
                if (input.isPressed('hat')) {
                    this.character.hat.activate();
                };
                if (input.isDown('up')) {
                    this.character.hat.accelerate(-1);
                }else if (input.isDown('down')) {
                    this.character.hat.accelerate(1);
                }else{
                    this.character.hat.accelerate(0);
                }
                if (input.isDown('left')) {
                    this.character.hat.lean(-1);
                }else if (input.isDown('right')) {
                    this.character.hat.lean(1);
                }
            }
        } else if (this.character && (!this.character.alive || this.levelWon)) {
            // Inside the simulated frame, so replays repeat it.
            if (this.vehicle && !this.vehicle.destroyed) this.vehicle.stopAccelerate();
            if (this.character.grabJointLeft || this.character.grabJointRight) this.character.release();
        }
    }

    this.handleInputAction = function(action, e = {}) {
        if (this.gameState === this.GAMESTATE_EDITOR && (action === 'test' || (this.run && action === 'pause'))) {
            if (this.run) this.stopTestingWorld(e);
            else if(action === 'test') this.testWorld(true);
            return true;
        }
        if (this.gameState === this.GAMESTATE_LOADINGDATA) return false;
        if (this.run && (this.gameOver || this.levelWon) && action === 'flip' && ui.endPromptShown()) {
            ui.revealEndScreen();
            return true;
        }
        if (this.run && ((this.gameOver && ['flip', 'retry'].includes(action)) || (this.levelWon && action === 'retry'))) {
            this.resetWorld(true);
            return true;
        }
        if (this.gameState === this.GAMESTATE_NORMALPLAY) {
            if(action === 'restart') {
                this.resetWorld(false);
                return true;
            }
            if(['pause', 'pauseMenu', 'retry'].includes(action)) {
                if(!this.pause) this.pauseGame();
                else {
                    this.unpauseGame();
                    if(this.run && action !== 'retry') this.gameplaySession.start();
                    if(action === 'retry') this.resetWorld(true);
                }
                return true;
            }
        }
        return false;
    }

    this.onKeyDown = function (e) {
        if(ReplayManager.isReplaying() && replayControls.onKeyDown(e)) return;
        if((menuNavigation.active && this.gameState !== this.GAMESTATE_MENU) || input.blocked || (document.activeElement !== document.body && document.activeElement !== this.canvas)) return;
        const editing = this.editor.editing && !this.run;
        const action = input.match(editing ? 'editor' : 'game', e);
        if(!e.repeat && this.handleInputAction(action, e)) {
            e.preventDefault();
            return;
        }
        // Native clipboard paste remains available; the internal paste shortcut
        // (Ctrl/Cmd+Shift+V by default) is independently configurable.
        if(editing && (e.ctrlKey || e.metaKey) && !e.shiftKey && e.keyCode === 86 && !action) return;
        Key.onKeydown(e);
        if(!editing && !e.repeat) input.queuePress(action);
        if(editing) {
            const translated = input.editorEvent(e, true);
            if(translated) {
                this.editor.onKeyDown(translated);
                input.syncEditorModifiers(this.editor);
                e.preventDefault();
            }
        } else if(action && this.gameState !== this.GAMESTATE_MENU) e.preventDefault();

        if(this.gameState === this.GAMESTATE_MENU){
            this.lastPressedKeys += e.key.toLowerCase();
            this.lastPressedKeys = this.lastPressedKeys.substr(Math.max(0, this.lastPressedKeys.length-20), this.lastPressedKeys.length);
            const cheats = ['thegift'];

            cheats.forEach(cheat => {
                if(this.lastPressedKeys.endsWith(cheat)){
                    const userData = SaveManager.getLocalUserdata();

                    switch(cheat){
                        case 'thegift':
                            userData.cheats.goldenPot = !userData.cheats.goldenPot;
                        break;
                    }

                    SaveManager.updateLocalUserData(userData);

		            AudioManager.playSFX('badoom2', 0.6, 1.0);
                }
            });

            if(e.key === '/'){
                const searchInput = document.querySelector('.search-input');
                if(searchInput){
                    if(document.activeElement !== searchInput){
                        searchInput.focus();
                        e.preventDefault();
                    }
                }
            }
        }


        if (['ArrowDown', 'ArrowUp', ' '].includes(e.key)) {
            e.preventDefault();
        }
    }
    this.onKeyUp = function (e) {
        // Always release held keys, even if a menu/chat took focus after keydown.
        Key.onKeyUp(e);
        const translated = input.editorEvent(e, false);
        if(translated) this.editor.onKeyUp(translated);
        input.syncEditorModifiers(this.editor);
    }
    this.cleanMenus = function(){
        this.initLevel(levelsData.singlePlayerLevel);
        this.editor.ui.hide();
        ui.show();

        ui.hideMainMenu();
        ui.hideSinglePlayer();
        ui.hideGameOverMenu();

        this.gameState = this.GAMESTATE_MENU;
        this.interactive = false;
        this.editor.editing = false;
        this.stopAutoSave();
        this.levelSession.end();

        this.triggerDebugDraw.debounceRedraw();
        GameTimer.show(false);

        if(!Settings.onPoki) history.replaceState({}, 'JollyWorld', '/');
    }

    this.openMainMenu = function(){
        this.cleanMenus();
        ui.showMainMenu();
    }

    this.openSinglePlayer = function (levelData) {
        if(multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE && game.gameState !== game.GAMESTATE_MULTIPLAYER_LEVELSELECT){
            leaveMultiplayer();
        }

        this.cleanMenus();
        ui.showSinglePlayer();

        if(levelData){
            ui.showLevelBanner(levelData);
        }

        const userdata = SaveManager.getLocalUserdata();

        if(!userdata.discordJoinShown && backendManager.needsDiscordJoin()){
            if(userdata.levelsPlayed >=3 || userdata.levelsPublished){
                ui.showDiscordJoin();
            }
        }
    }

    this.runWorld = function () {
        this.editor.runWorld();
        MobileController.configureLevel(this.currentLevelData, this.editor.triggerObjects);
        this.run = true;
        this.findPlayableCharacter();
    }
    this.playWorld = function (firstEntry, waitingForPlayers = false) {
        ReplayManager.beginAttempt(this);

        this.movementBuffer = [];
        MobileController.openFullscreen();
        MobileController.showVehicleControls();
        this.runWorld();
        this.gameState = this.GAMESTATE_NORMALPLAY;
        if(firstEntry){
            this.levelStartTime = performance.now();
            this.gameFrame = 0;
            MidiPlayer.reset();
            window.SVGCache[1]();

            const userData = SaveManager.getLocalUserdata();
            userData.levelsPlayed++;
            SaveManager.updateLocalUserData(userData);

        }
        if(!waitingForPlayers) this.gameplaySession.start();
        MobileController.show();
        ui.showSmallLogo();
        if(!MobileController.isMobile() && !this.tutorialMode){
            ui.showInGameButs();
        }
        this.playLevelMidi();
        GameTimer.show(true);

        this.playedFirstLevel = true;
    }

    this.testWorld = function (firstEntry) {
        this.movementBuffer = [];
        this.editor.testWorld();
        MobileController.configureLevel(this.currentLevelData, this.editor.triggerObjects);
        this.run = true;
        this.findPlayableCharacter();
        this.stopAutoSave();
        this.levelStartTime = performance.now();
        this.gameFrame = 0;
        MobileController.show();
        if(firstEntry){
            MidiPlayer.reset();
        }
        this.playLevelMidi();
        this.triggerDebugDraw.debounceRedraw();
        GameTimer.show(true);
    }
    this.playLevelMidi = function (){
        const userdata = SaveManager.getLocalUserdata();
        if(this.editor.editorSettingsObject.song && editor.editorSettingsObject.autoPlayMidi && userdata.musicOn){
            MidiPlayer.play();
        }
    }
    this.stopTestingWorld = function () {
        this.stopWorld();
        ui.hideWinScreen();
        var worldJSON = JSON.parse(this.editor.worldJSON);
        this.editor.buildJSON(worldJSON);
        this.doAutoSave();
        GameTimer.show(false);
    }
    // Box2D keeps history in a world: proxy ids come from a free list, so the
    // same level collides in a different order in a reused world. Every rebuild
    // gets a fresh world, and wrappers of the old one are dropped so properties
    // set on destroyed bodies cannot resurface on a new body at the same address.
    this.replacePhysicsWorld = function () {
        Box2D.destroy(this.world);
        for(const name of box2DWorldClasses){
            const cache = Box2D.getCache(Box2D[name]);
            for(const pointer in cache) delete cache[pointer];
        }
        const gravity = new b2Vec2(0, 10);
        this.world = new b2World(gravity);
        Box2D.destroy(gravity);
        const bodyDef = new Box2D.b2BodyDef();
        this.m_groundBody = this.world.CreateBody(bodyDef);
        Box2D.destroy(bodyDef);
        this.mouseJoint = null;
        this.editor.world = this.world;
        this.world.SetContactListener(this.editor.B2dEditorContactListener);
        b2DebugDrawManager.attach();
    }
    this.replayPlayerName = function () {
        return backendManager.isLoggedIn() ? backendManager.userData?.username ?? null : null;
    }
    const replayUploads = new WeakMap();
    this.uploadReplay = function (replay) {
        const known = replayUploads.get(replay);
        if(known?.attempts === replay.attempts.length) return known.id;
        const upload = ReplayManager.encodeReplayForUpload(replay);
        const id = backendManager.submitReplay(replay.level.id, upload, !!replay.finished).catch(() => null);
        replayUploads.set(replay, {attempts: replay.attempts.length, id});
        return id;
    }
    this.replayLink = async function (replay = ReplayManager.getLastReplay()) {
        if(!replay) return null;
        const uploadable = replayUploads.has(replay) || (replay.level.md5 && backendManager.isLoggedIn());
        const id = uploadable ? await this.uploadReplay(replay) : null;
        return id ? PokiSDK.shareableURL({replay: id}) : null;
    }
    this.openReplayLink = async function (id) {
        if(!/^[A-Za-z_~]{21}$/.test(id)) return;
        try{
            const replay = await backendManager.loadReplay(id);
            replayUploads.set(replay, {attempts: replay.attempts.length, id: Promise.resolve(id)});
            const levelData = await backendManager.getPublishedLevelInfo(replay.level.id);
            await this.loadPublishedLevelData(levelData, () => {});
            this.playReplay(replay);
        }catch(error){
            console.warn('Could not open the replay link', error);
        }
    }
    this.playReplay = function (data = ReplayManager.getLastReplay()) {
        const replay = ReplayManager.parseReplay(data);
        let level = replay.level;
        if(!level.json){
            if(this.currentLevelData?.id !== level.id) throw new Error(`Open level ${level.id} to watch this replay`);
            if(level.md5 && this.currentLevelData.level_md5 !== level.md5) console.warn('The level changed since this replay was recorded');
            level = this.currentLevelData;
            replay.level.title = level.title;
        }
        this.cleanMenus();
        const selection = [this.selectedCharacter, this.selectedVehicle, this.selectedMask];
        this.selectedCharacter = replay.character;
        this.selectedVehicle = replay.vehicle;
        this.selectedMask = replay.mask;
        const isThisReplay = () => ReplayManager.replayStatus()?.replay === replay;
        let quiet = 0;
        ReplayManager.queueReplay(replay, {
            onAttemptEnd: () => setTimeout(() => {
                if(isThisReplay()) this.playReplayAttempt(ReplayManager.nextAttempt());
            }, 400),
            onTimerStart: (gameFrame, attempt) => {
                this.gameFrame = gameFrame;
                window.SVGCache[1](!!attempt.checkpoint);
            },
            // Recordings stop at the finish; run on until the character's last line is over.
            runOn: frames => {
                quiet = this.character?.characterVoice?.handle?.playing() ? 0 : quiet + 1;
                return frames < 600 && (frames < 60 || quiet < 30);
            },
            onEnd: () => {
                [this.selectedCharacter, this.selectedVehicle, this.selectedMask] = selection;
                replayControls.hide();
            },
        });
        this.currentLevelData = {...level};
        // The win screen prefers the last submitted time, which is not this run's.
        delete window.wqhjfu;
        replayControls.show({
            restart: () => this.playReplay(replay),
            exit: () => this.exitReplay(),
            link: () => this.replayLink(replay),
        });
        this.playReplayAttempt(replay.attempts[0]);
    }
    this.playReplayAttempt = function (attempt) {
        this.initLevel(this.currentLevelData);
        this.playWorld(!attempt.checkpoint);
        ui.hideInGameButs();
        MobileController.hide();
        if(attempt.checkpoint){
            this.applyCheckpoint(attempt.checkpoint);
            this.gameFrame = attempt.checkpoint.frame;
        }
    }
    this.exitReplay = function () {
        const level = this.currentLevelData;
        ReplayManager.stopReplay();
        this.openSinglePlayer(level?.level_md5 ? level : undefined);
    }
    this.applyCheckpoint = function (checkPointData) {
        const prefabLookupObject = this.editor.lookupGroups[this.playerPrefabObject.key];
        const allObjects = [].concat(prefabLookupObject._bodies, prefabLookupObject._textures, prefabLookupObject._joints);

        const positionDiff = {x:checkPointData.x*this.editor.PTM-this.playerPrefabObject.x, y:checkPointData.y*this.editor.PTM-this.playerPrefabObject.y, }

        const perpendularAngle = checkPointData.rotation - Math.PI/2;
        const checkPointOffset = 200;
        positionDiff.x += checkPointOffset*Math.cos(perpendularAngle);
        positionDiff.y += checkPointOffset*Math.sin(perpendularAngle);

        if(this.playerPrefabObject.class.character.hat){
            const hatBody = this.playerPrefabObject.class.character.hat.hatBody;
            const position = vec1;
            position.set_x(hatBody.GetPosition().get_x() + positionDiff.x / Settings.PTM);
            position.set_y(hatBody.GetPosition().get_y() + positionDiff.y / Settings.PTM);

            hatBody.SetTransform(position, hatBody.GetAngle());
        }

        this.editor.applyToObjects(this.editor.TRANSFORM_MOVE, positionDiff, allObjects);
        this.editor.applyToObjects(this.editor.TRANSFORM_ROTATE, checkPointData.rotation, allObjects);

        prefabLookupObject._bodies.forEach(body =>{
            this.editor.updateBodyPosition(body);
        });
        this.checkPointData = checkPointData;

        if(this.checkPointData.flipped) this.character.flip();

        if(this.checkPointData.persistentTriggers.length){
            game.editor.textures.children.forEach(texture => {
                if(texture.data && texture.data.type === game.editor.object_TRIGGER){
                    if(this.checkPointData.persistentTriggers.includes(texture.checkpointIndex)){
                        const trigger = texture.myBody.class;
                        trigger.doTrigger();
                        trigger.actionQueue.length = 0;
                        trigger.destroy = true;
                    }
                }
            });
            game.editor.persistentTriggers = [...this.checkPointData.persistentTriggers];
        }
        ReplayManager.recordCheckpoint(checkPointData);
    }
    this.resetWorld = function (doCheckpoint) {
        if(this.gameState == this.GAMESTATE_NORMALPLAY) this.levelSession.retry();
        game.preloader.classList.remove('hide');
        setTimeout(()=>{
            const checkPointData = this.checkPointData;
            this.resetGame();
            ui.hideWinScreen();
            ui.hideGameOverMenu();

            if(doCheckpoint && this.editor.editorSettingsObject.song && !this.editor.editorSettingsObject.resetMidiOnRetry){
                MidiPlayer.pause();
            }else{
                MidiPlayer.stop();
            }

            if (this.gameState == this.GAMESTATE_EDITOR) {
                this.stopTestingWorld();
                this.testWorld();
            }else if(this.gameState == this.GAMESTATE_NORMALPLAY){
                this.initLevel(this.currentLevelData);
                this.playWorld(!doCheckpoint);
            }

            // A death before the timer restarts below reads this frame.
            this.gameFrame = doCheckpoint && checkPointData ? checkPointData.frame : 0;
            if(doCheckpoint && checkPointData) this.applyCheckpoint(checkPointData);


            setTimeout(()=>{
                game.preloader.classList.add('hide');

                if(doCheckpoint && checkPointData){
                    this.levelStartTime = performance.now() - checkPointData.time;
                    this.gameFrame = checkPointData.frame;
                }else{
                    this.levelStartTime = performance.now();
                    this.gameFrame = 0;
                }
                ReplayManager.recordTimerStart(this.gameFrame);

                window.SVGCache[1](doCheckpoint);

            }, Settings.levelBuildDelayTime);
        }, Settings.levelBuildDelayTime);
    }
    this.stopWorld = function () {
        this.movementBuffer = [];
        ExplosionManager.reset();
        BreakableManager.reset();
        emitterManager.reset();
        ExplosionEffects.reset();
        resetHitstop();
        this.editor.resetEditor();
        this.run = false;
        MobileController.configureLevel(null, []);
        this.resetGame();
        ui.hideGameOverMenu();
        PhysicsParticleEmitter.update(true);
        MobileController.hide();
        AudioManager.stopAllSounds();
        SlowmoUI.hide();
        ui.hideSmallLogo();
        ui.hideInGameButs();
        MidiPlayer.stop();
        ReplayManager.endAttempt();

        this.gameplaySession.stop();

    }
    this.openEditor = async function (portalLabRequested = false) {
        this.gameState = this.GAMESTATE_EDITOR;

        this.stopWorld();

        let levelData;
        portalLabRequested = portalLabRequested ||
            new URLSearchParams(window.location.search).get('portalLab') === '1';
        if(portalLabRequested){
            levelData = levelsData.portalLab();
        }else{
            try{
                levelData = await SaveManager.getTempEditorWorld();
            }catch(err){
                // error
                levelData = null;
            }
        }
        if(!levelData){
            levelData = levelsData.editorLevel();
            levelData.id = nanoid();
            levelData.creationDate = Date.now();
        }

        this.initLevel(levelData);
        this.doAutoSave();
        this.editor.editing = true;
        ui.hide();

        const minScreenSize = 640;
        const maxScreenSize = 1300;
        const screenSizeDif = maxScreenSize - minScreenSize;
        const minScale = 0.4;
        const maxScale = 1.0;
        const scaleDiff = maxScale - minScale;

        const screenPercent = Math.max(0, Math.min(1.0, (window.innerWidth - minScreenSize) / screenSizeDif));
        const targetScale = scaleDiff * screenPercent + minScale;

        setZoom({x:0, y:0}, targetScale)

        if(betterLocalStorage.getItem('needsToRegister')){
			backendManager.dispatchEvent('username');
		}
    }
    this.initLevel = function (data) {
        this.stopWorld();
        AudioManager.releaseOptionalAudio();
        this.currentLevelData = data;
        this.editor.worldJSON = data.json;
        this.editor.ui.setLevelSpecifics();
        this.editor.buildJSON(data.json);
        if(this.editor.editorSettingsObject.song) MidiPlayer.startLoad(this.editor.editorSettingsObject.song);

        if(backendManager.isLoggedIn() && backendManager.userData && data.id){
            window.SVGCache[0](backendManager.userData.id, data.id, game.selectedCharacter)
        }
    }
    this.pauseGame = function(){
        if(this.gameOver || this.levelWon || this.tutorialMode) return;
        this.pause = true;
        this.run = false;
        ui.showPauseMenu();
        AudioManager.stopAllSounds();
        MobileController.hide();

        this.exitPointerLock();

        this.gameplaySession.stop();
    }
    this.unpauseGame = function(){
        this.pause = false;
        if(![HUD_STATES.WAITING_PLAYERS, HUD_STATES.COUNTDOWN].includes(hudState)){
            this.run = true;
        }
        ui.hidePauseMenu();
        MobileController.show();
    }
    this.resetGame = function(){
        this.levelWon = false;
        this.gameOver = false;
        this.checkPointData = null;
        this.character = null;
        this.vehicle = null;
        this.cameraFocusObject = null;
    }

    this.autoSaveTimeOutID;
    this.doAutoSave = function () {
        let self = this;
        this.stopAutoSave();
        this.autoSaveTimeOutID = setTimeout(() => {
            if(!self.currentLevelData?.portalLab && !self.editor.lockSaving && !self.IS_ERROR){
                self.currentLevelData.json = game.editor.worldJSON;
                SaveManager.saveTempEditorWorld(self.currentLevelData);
            }
            self.doAutoSave();
        }, Settings.autoSaveInterval);
    }
    this.stopAutoSave = function () {
        clearTimeout(this.autoSaveTimeOutID);
        this.autoSaveTimeOutID = undefined;
    }
    this.newLevel = function () {
        // A new level forces its vehicle; levels already saved keep the setting they were made with.
        const vehicle = 'Bike';
        let data = {
            json: `{"objects":[[4,0,0,0,{"selectedVehicle":"${vehicle}","life":300,"forceVehicle":true},"${vehicle}",0]],"settings":[10,0,10]}`,
            title: '',
            description: '',
            crossPromos: [],
            creationDate: Date.now(),
            forced_vehicle: Settings.availableVehicles.indexOf(vehicle) + 1,
            id: nanoid(),
        }
        this.initLevel(data);
        SaveManager.saveTempEditorWorld(this.currentLevelData);
    }
    this.saveNewLevelData = function () {
        game.currentLevelData.id = nanoid();
        return this.saveLevelData();
    }
    this.saveLevelData = function () {
        return new Promise((resolve, reject) => {
            backendManager.uploadUserLevelData(game.currentLevelData, game.editor.stringifyWorldJSON(), game.editor.cameraShotData).then((levelData) => {
                this.currentLevelData = levelData;
                game.currentLevelData.saved = true;
                game.editor.cameraShotData = null;
                SaveManager.saveTempEditorWorld(self.currentLevelData);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }
    this.publishLevelData = function () {
        return new Promise((resolve, reject) => {
            backendManager.publishLevelData(game.currentLevelData).then(levelData => {
                resolve(levelData);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    this.deleteLevelData = function () {
        return backendManager.deleteUserLevelData(game.currentLevelData);
    }
    this.levelHasChanges = function () {
        if (game.currentLevelData.json != game.editor.stringifyWorldJSON()) return true;
        return false;
    }
    this.gameCheckpoint = function (object, id) {
        if(this.gameOver || this.levelWon) return;
        if(!this.checkPointData || id !== this.checkPointData.id){
            const confettiPosition = vec1;
            confettiPosition.Set(object.GetPosition().x, object.GetPosition().y);
            const confettiOffset = 3.0;
            const offsetAngle = object.GetAngle() - Settings.pihalve;

            confettiPosition.set_x(confettiPosition.get_x() + confettiOffset * Math.cos(offsetAngle));
            confettiPosition.set_y(confettiPosition.get_y() + confettiOffset * Math.sin(offsetAngle));

            emitterManager.playOnceEmitter("confetti", object, confettiPosition, 0, ['#27cdcb', '#333333']);
		    AudioManager.playSFX('checkpoint', 0.2, 1.0 + 0.4 * Math.random()-0.2, object.GetPosition());

            this.checkPointData = {
                x:object.GetPosition().x,
                y:object.GetPosition().y,
                rotation:object.GetAngle(),
                object,
                flipped:this.character.flipped,
                time: performance.now() - this.levelStartTime,
                frame: this.gameFrame,
                persistentTriggers: [...new Set(this.editor.persistentTriggers)],
                id,
                // save checkpoint time
            }

            if(multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE){
                sendCheckpoint();
            }

            window.SVGCache[3]();
        }
    }
    this.gameWin = async function () {
        if (!this.gameOver && !this.levelWon) {
            this.levelWon = true;
            recordReplayEvent('finish');
            this.gameplaySession.stop();
            this.character?.playVoice('win');
            // GAME STATE NORMAL

            const multiplayer = multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE;
            if(!multiplayer){

                if(multiplayerState.lobbyState === LOBBY_STATE.VOTING) return;

                if(this.gameState == this.GAMESTATE_NORMALPLAY && !ReplayManager.isReplaying()){
                    this.levelSession.finish();
                    ReplayManager.recordFinish();
                    const replay = ReplayManager.getCurrentReplay();
                    if(replay?.level?.md5) this.uploadReplay(replay);
                    await backendManager.submitTime(game.currentLevelData.id);
                }

                let d;
                if(window.wqhjfu){
                d = timeFormat(window.wqhjfu);
                }else{
                d = timeFormat(this.gameFrame * (1/60) * 1000);
                }

                const s = d.hh !== '00' ? `${d.hh}:${d.mm}:${d.ss}.` : `${d.mm}:${d.ss}.`;
                if(ReplayManager.isReplaying()){
                    replayControls.showFinish(`${s}${d.ms}`);
                }else if(this.gameState == this.GAMESTATE_EDITOR){
                    ui.show();
                    ui.showWinScreen(s, d.ms);
                }else if(this.gameState == this.GAMESTATE_NORMALPLAY){;
                    ui.showWinScreen(s, d.ms);
                }
            }else{
                const d = this.gameFrame * (1/60) * 1000;
                sendLevelWon(d);
            }

            this.editor.ui.showConfetti();
                MobileController.hide();
                GameTimer.show(false);

            this.exitPointerLock();
        }
    }
    this.gameLose = function () {

        const multiplayerAllowed = multiplayerState.lobbyState === LOBBY_STATE.OFFLINE || multiplayerState.lobbyState === LOBBY_STATE.PLAYING;


        if (!this.gameOver && !this.levelWon && (this.gameState === this.GAMESTATE_NORMALPLAY || this.gameState === this.GAMESTATE_EDITOR) && multiplayerAllowed) {

            this.gameplaySession.stop();
            const d = timeFormat(this.gameFrame * (1/60) * 1000);
            const s = d.hh !== '00' ? `${d.hh}:${d.mm}:${d.ss}.` : `${d.mm}:${d.ss}.`;
            if(!ReplayManager.isReplaying()){
                ui.show();
                ui.showGameOver(s, d.ms);
            }
            MobileController.hide();
            this.gameOver = true;

            this.exitPointerLock();

            if(multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE){
                sendGameOver();
            }
        }
    }

    this.exitPointerLock = function () {
        try{
            document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock;
            if(document.exitPointerLock) document.exitPointerLock();
        }catch(err){

        }
    }

    this.loadUserLevelData = function (levelData) {
        if(!isLevelCompatible(levelData)) {
            alert(LEVEL_VERSION_ERROR);
            return Promise.reject(new Error(LEVEL_VERSION_ERROR));
        }
        return new Promise((resolve, reject) => {
            game.currentLevelData = levelData;

			const body = {
				method: 'GET',
			}

            // fetch(`${Settings.STATIC}/6e785dcebe185763a81fdb29f677dd59.json`, body)
            fetch(`${Settings.STATIC}/${levelData.level_md5}.json`, body)
            .then(response => response.json())
            .then(data => {
                this.currentLevelData.json = JSONStringify(data);
                this.currentLevelData.saved = true;
                this.initLevel(this.currentLevelData);
                SaveManager.saveTempEditorWorld(this.currentLevelData);
                return resolve();
            }).catch((err)=>{
                throw err;
                return reject({
                    message: err
                });
            })
        });
    }
    this.loadPublishedLevelData = function (levelData, progressFunction) {
        if(!isLevelCompatible(levelData)) {
            alert(LEVEL_VERSION_ERROR);
            return Promise.reject(new Error(LEVEL_VERSION_ERROR));
        }
        return new Promise(async (resolve, reject) => {
            game.currentLevelData = levelData;

            const req = new XMLHttpRequest();
            req.overrideMimeType("application/json");
            req.open('GET', `${Settings.STATIC}/${levelData.level_md5}.json`, true);
            req.onload  = ()=> {
                self.currentLevelData.json = JSON.parse(req.responseText);
                return resolve();
            };

            req.onprogress = e => {
                const progress = e.loaded / req.compressedContentLength;
                progressFunction(progress);
            }
            req.onerror = err => {
                console.log('fail', err);
                game.gameState = game.GAMESTATE_MENU;
                return reject({
                    message: err
                });
            }
            req.onreadystatechange = function() {
                if(this.readyState == this.HEADERS_RECEIVED) {
                    try{
                        req.compressedContentLength = req.getResponseHeader("x-decompressed-content-length") || 1000000;
                    }catch(e){
                        req.compressedContentLength = 1000000;
                    }
                }
            }
            req.send(null);
        });
    }


    this.findPlayableCharacter = function () {
        for (var key in this.editor.activePrefabs) {
            if (this.editor.activePrefabs.hasOwnProperty(key)) {
                if (this.editor.activePrefabs[key].class.constructor.playableCharacter) {
                    this.playerPrefabObject = this.editor.activePrefabs[key];

                    this.character = this.editor.activePrefabs[this.playerPrefabObject.class.lookupObject.character.body.mySprite.data.subPrefabInstanceName].class;
                    this.vehicle = this.editor.activePrefabs[this.playerPrefabObject.class.prefabObject.key].class;
                    this.cameraFocusObject = this.cameraFocusCharacterObject = this.character.lookupObject.body;
                    this.character.startVoice();

                    var bodies = this.editor.lookupGroups[this.playerPrefabObject.key]._bodies;
                    bodies.forEach(body => {
                        body.mainCharacter = true;
                        PIXICuller.disableCulling(body.mySprite);
                    });
                    break;
                }
            }
        }
    }
    this.movementBufferSize = 60;
    // World pixels kept between the followed object and the screen edges, which the look-ahead would
    // otherwise run past on portrait screens. The vehicle hangs below the player, so the bottom keeps more.
    this.cameraFocusMargin = {x: 200, top: 150, bottom: 320};
    this.movementBuffer = [];
    this.gameCamera = function (instant) {
        const panEase = !instant ? this.editor.editorSettingsObject.cameraEase : 1.0;
        const zoomEase = !instant ? this.editor.editorSettingsObject.cameraEase : 1.0;
        const camera = this.editor.cameraHolder;

        const currentZoom = camera.scale.x;
        const targetZoom = Settings.aspectZoom * this.editor.editorSettingsObject.cameraZoom;

        let cameraTargetPosition;
        if(this.cameraFocusObject && !this.cameraFocusObject.destroyed){
            cameraTargetPosition = this.editor.getPIXIPointFromWorldPoint(this.cameraFocusObject.GetPosition());
            this.lastKnownCameraPoint = {x:cameraTargetPosition.x, y:cameraTargetPosition.y};
        }else if(this.lastKnownCameraPoint){
            cameraTargetPosition = {x:this.lastKnownCameraPoint.x, y:this.lastKnownCameraPoint.y};
        }

        if(!cameraTargetPosition) return;
        const focus = {x: cameraTargetPosition.x, y: cameraTargetPosition.y};

        this.editor.camera.setZoom(cameraTargetPosition, currentZoom + (targetZoom - currentZoom) * zoomEase);

        cameraTargetPosition.x -= window.innerWidth / 2.0 / camera.scale.x;
        cameraTargetPosition.y -= window.innerHeight / 2.0 / camera.scale.y;
        cameraTargetPosition.x *= camera.scale.x;
        cameraTargetPosition.y *= camera.scale.y;

        let offsetX = 0;
        let offsetY = 0;

        let newVec;
        if(this.movementBuffer.length > this.movementBufferSize){
            newVec = this.movementBuffer.shift();
        }else{
            newVec = new Box2D.b2Vec2(0,0);
        }

        if(this.cameraFocusObject){
            newVec.Set(this.cameraFocusObject.GetLinearVelocity().x, this.cameraFocusObject.GetLinearVelocity().y)
        }
        this.movementBuffer.push(newVec);


        if(this.movementBuffer.length){
            for(let i = 0; i<this.movementBuffer.length; i++){
                offsetX += this.movementBuffer[i].get_x();
                offsetY += this.movementBuffer[i].get_y();
            }
            offsetX /= this.movementBufferSize;
            offsetY /= this.movementBufferSize;
        }

        const speedBuffer = 20 * (1 - this.editor.editorSettingsObject.cameraEase - 0.1 / 0.9);
        const movementBufferScale = speedBuffer * camera.scale.x;

        const margin = this.cameraFocusMargin;
        const marginX = Math.min(margin.x * camera.scale.x, window.innerWidth * 0.4);
        const marginTop = Math.min(margin.top * camera.scale.y, window.innerHeight * 0.4);
        const marginBottom = Math.min(margin.bottom * camera.scale.y, window.innerHeight * 0.4);
        const leadX = window.innerWidth / 2 - marginX;
        cameraTargetPosition.x += Math.max(-leadX, Math.min(leadX, offsetX * movementBufferScale));
        cameraTargetPosition.y += Math.max(marginBottom - window.innerHeight / 2, Math.min(window.innerHeight / 2 - marginTop, offsetY * movementBufferScale));

        const movX = (-cameraTargetPosition.x - camera.x) * panEase;
        const movY = (-cameraTargetPosition.y - camera.y) * panEase;

        camera.x += movX;
        camera.y += movY;

        // The lag can still carry the followed object out when it turns around. Once it is inside the
        // margins it is kept there; a new camera target or a teleport pans in as before.
        const focusX = focus.x * camera.scale.x + camera.x;
        const focusY = focus.y * camera.scale.y + camera.y;
        const hold = this.cameraHold;
        if(hold && (hold.object !== this.cameraFocusObject || Math.abs(focus.x - hold.x) + Math.abs(focus.y - hold.y) > 150)) this.cameraHold = null;
        if(this.cameraHold){
            camera.x += Math.max(0, marginX - focusX) - Math.max(0, focusX - (window.innerWidth - marginX));
            camera.y += Math.max(0, marginTop - focusY) - Math.max(0, focusY - (window.innerHeight - marginBottom));
        }else if(focusX >= marginX && focusX <= window.innerWidth - marginX && focusY >= marginTop && focusY <= window.innerHeight - marginBottom){
            this.cameraHold = {object: this.cameraFocusObject};
        }
        if(this.cameraHold){
            this.cameraHold.x = focus.x;
            this.cameraHold.y = focus.y;
        }

        window.SVGCache?.[4]?.();

        this.myEffectsContainer.scale.x = camera.scale.x;
        this.myEffectsContainer.scale.y = camera.scale.y;
        this.myEffectsContainer.x = camera.x;
        this.myEffectsContainer.y = camera.y;

        // position slowmotion UI
        SlowmoUI.ui.x = (-this.myEffectsContainer.x + window.innerWidth / 2.0) / camera.scale.x;
        SlowmoUI.ui.y = (-this.myEffectsContainer.y  + 20) / camera.scale.x;
        SlowmoUI.ui.scale.x = SlowmoUI.ui.scale.y = (1/camera.scale.x) * 0.5;
    }

    var self = this;
    this.gameContactListener = new JSContactListener();
    this.gameContactListener.BeginContact = function (contact) {
        const currentTime = Date.now();
        let target = contact.GetFixtureA().GetBody();
        if(target.ignoreCollisionsTime && target.ignoreCollisionsTime>currentTime) contact.SetEnabled(false);
        else if(target.ignoreCollisionsTime && target.ignoreCollisionsTime<currentTime) target.ignoreCollisionsTime = undefined;

        target = contact.GetFixtureB().GetBody();
        if(target.ignoreCollisionsTime && target.ignoreCollisionsTime>currentTime) contact.SetEnabled(false);
        else if(target.ignoreCollisionsTime && target.ignoreCollisionsTime<currentTime) target.ignoreCollisionsTime = undefined;
    }
    this.gameContactListener.EndContact = function (contact) {
        const bodyA = contact.GetFixtureA().GetBody();
        const bodyB = contact.GetFixtureB().GetBody();

        if(bodyA.recentlyImpactedBodies && bodyA.recentlyImpactedBodies.includes(bodyB)){
            if(bodyA.recentlyImpactedBodies.length === 1) delete bodyA.recentlyImpactedBodies;
            else bodyA.recentlyImpactedBodies = bodyA.recentlyImpactedBodies.filter(body=>body != bodyB);
        }
        if(bodyB.recentlyImpactedBodies && bodyB.recentlyImpactedBodies.includes(bodyA)){
            if(bodyB.recentlyImpactedBodies.length === 1) delete bodyB.recentlyImpactedBodies;
            else bodyB.recentlyImpactedBodies = bodyB.recentlyImpactedBodies.filter(body=>body != bodyA);
        }
    }

    this.gameContactListener.PreSolve = function (contact) {
        if(shouldDisablePortalContact(contact)) {
            contact.SetEnabled(false);
            return;
        }
        const bodies = [contact.GetFixtureA().GetBody(), contact.GetFixtureB().GetBody()];
        let body;
        let otherBody;

        if(!bodies[0].mySprite || !bodies[1].mySprite) return;

        if(contact.GetFixtureA().GetBody().mainCharacter || contact.GetFixtureB().GetBody().mainCharacter){
            if([].concat(contact.GetFixtureA().GetBody().mySprite.data.collision).includes(1) || [].concat(contact.GetFixtureB().GetBody().mySprite.data.collision).includes(1)){
                contact.SetEnabled(false);
                return;
            }
        }

        for (let i = 0; i < bodies.length; i++) {
            body = bodies[i];
            otherBody = i == 0 ? bodies[1] : bodies[0];
            if(body.mySprite.data.prefabInstanceName && body.mySprite.data.prefabInstanceName != otherBody.mySprite.data.prefabInstanceName){
                const velocity = body.GetLinearVelocity();
                body.oldBounceManifest = {x: velocity.x, y: velocity.y};
            }
        }
    }
    this.gameContactListener.PostSolve = function (contact, impulse) {
        const bodies = [contact.GetFixtureA().GetBody(), contact.GetFixtureB().GetBody()];
        let body;
        let otherBody;

        if(!bodies[0].mySprite || !bodies[1].mySprite) return;


        for (let i = 0; i < bodies.length; i++) {
            body = bodies[i];
            otherBody = i == 0 ? bodies[1] : bodies[0];
            const otherFixture = i == 0 ? contact.GetFixtureB() : contact.GetFixtureA();

            if(body.mySprite.data.prefabInstanceName && body.mySprite.data.prefabInstanceName != otherBody.mySprite.data.prefabInstanceName){
                if(body.oldBounceManifest && otherFixture.GetRestitution()>=0.5){

                    const velocityBoostX = (body.GetLinearVelocity().get_x() - body.oldBounceManifest.x);
                    const velocityBoostY = (body.GetLinearVelocity().get_y() - body.oldBounceManifest.y);

                    if(Math.sqrt(velocityBoostX*velocityBoostX + velocityBoostY * velocityBoostY) > 5){
                        for (let jointEdge = body.GetJointList(); getPointer(jointEdge) !== getPointer(NULL); jointEdge = jointEdge.get_next()) {
                            const joint = jointEdge.joint;
                            const connectedBody = joint.GetBodyA() === body ? joint.GetBodyB() : joint.GetBodyA();
                            const velocity = connectedBody.GetLinearVelocity();
                            if(Math.abs(velocity.x-body.GetLinearVelocity().get_x()) > Math.abs(velocityBoostX)/2) velocity.x += velocityBoostX*Settings.prefabBounceLimiter;
                            if(Math.abs(velocity.y-body.GetLinearVelocity().get_y()) > Math.abs(velocityBoostY)/2) velocity.y += velocityBoostY*Settings.prefabBounceLimiter;

                            for (let innerJointEdge = connectedBody.GetJointList(); getPointer(innerJointEdge) !== getPointer(NULL); innerJointEdge = innerJointEdge.get_next()) {
                                const innerConnectedBody = innerJointEdge.joint.GetBodyA() === connectedBody ? innerJointEdge.joint.GetBodyB() : innerJointEdge.joint.GetBodyA();
                                if(innerConnectedBody != body){
                                    const innerVelocity = innerConnectedBody.GetLinearVelocity();
                                    if(Math.abs(innerVelocity.x-body.GetLinearVelocity().get_x()) > Math.abs(velocityBoostX)/2) innerVelocity.x += velocityBoostX*Settings.prefabBounceLimiter;
                                    if(Math.abs(innerVelocity.y-body.GetLinearVelocity().get_y()) > Math.abs(velocityBoostY)/2) innerVelocity.y += velocityBoostY*Settings.prefabBounceLimiter;
                                }
                            }
                        }

                    }
                    delete body.oldBounceManifest;
                }
            }

            let force = 0;
            for (let j = 0; j < impulse.get_count(); j++){
                if (impulse.get_normalImpulses(j) > force){
                    force = impulse.get_normalImpulses(j);
                }
            }

            BodyBreaker.checkBodyBreak(body, force);
            BodyBreaker.checkBodyBreak(otherBody, force);

            if ((body.isFlesh && !body.snapped) && (bodies[0].mySprite.data.prefabID != bodies[1].mySprite.data.prefabID || bodies[0].mySprite.data.prefabID == undefined)) {
                if(otherBody.instaKill){
                    const bodyClass = self.editor.retrieveSubClassFromBody(body);
                    if(bodyClass && bodyClass.dealDamage){
                        bodyClass.dealDamage(10000);
                    }
                }else if(!otherBody.isVehiclePart && !otherBody.noImpactDamage) {


                    const bodyA = contact.GetFixtureA().GetBody();
                    const bodyB = contact.GetFixtureB().GetBody();

                    const velocityA = contact.GetFixtureA().GetBody().GetLinearVelocity().Length();
                    const velocityB = contact.GetFixtureB().GetBody().GetLinearVelocity().Length();
                    let impactAngle = (velocityA > velocityB) ? Math.atan2(contact.GetFixtureA().GetBody().GetLinearVelocity().get_y(), contact.GetFixtureA().GetBody().GetLinearVelocity().get_x()) : Math.atan2(contact.GetFixtureB().GetBody().GetLinearVelocity().get_y(), contact.GetFixtureB().GetBody().GetLinearVelocity().get_x());
                    impactAngle *= game.editor.RAD2DEG + 180;
                    const velocitySum = velocityA + velocityB;

                    let allowSound = true;
                    if(bodyA.recentlyImpactedBodies && bodyA.recentlyImpactedBodies.includes(bodyB)) allowSound = false;
                    if(bodyB.recentlyImpactedBodies && bodyB.recentlyImpactedBodies.includes(bodyA)) allowSound = false;

                    const skipBecauseToLight = contact.GetFixtureA().GetDensity() === 0.001 || contact.GetFixtureB().GetDensity() === 0.001;

                    // Parts with an impactSpeed only bleed from hits that change their speed by at least that much.
                    const hardEnough = !body.impactSpeed || force > body.GetMass() * body.impactSpeed;
                    if (velocitySum > 10.0 && hardEnough && !skipBecauseToLight && (!body.decalTimeout || simulationTime() > body.decalTimeout)) {
                        body.decalTimeout = simulationTime() + Settings.decalTimeout
                        const worldManifold = new Box2D.b2WorldManifold();
                        contact.GetWorldManifold(worldManifold);
                        const worldCollisionPoint = worldManifold.get_points(0);

                        const slidingDecalSlider = 50;
                        const goreSize = Math.min(2, velocitySum/slidingDecalSlider);

                        if(allowSound) AudioManager.playSFX(['bodyhit1', 'bodyhit2','bodyhit3'], 0.1, 1.4 + 0.4 * Math.random()-0.2, body.GetPosition());

                        if(!bodyA.recentlyImpactedBodies) bodyA.recentlyImpactedBodies = [];
                        bodyA.recentlyImpactedBodies.push(bodyB);

                        const bodyClass = self.editor.retrieveSubClassFromBody(body);
                        if(bodyClass && bodyClass.dealDamage && !body.noDamage){

                            if(!bodyClass.invincible){
                                const slidingDamageScalar = 50;
                                bodyClass.dealDamage(velocitySum/slidingDamageScalar);
                                self.editor.queueDecalToBody(body, worldCollisionPoint, "Decal.png", true, goreSize);
                                emitterManager.playOnceEmitter("blood", body, worldCollisionPoint, impactAngle);
                            }
                        }
                    }
                }
            }else{
                const bodyA = contact.GetFixtureA().GetBody();
                const bodyB = contact.GetFixtureB().GetBody();

                const velocityA = Math.max(bodyA.GetLinearVelocity().Length(), Math.abs(bodyA.GetAngularVelocity()));
                const velocityB = Math.max(bodyB.GetLinearVelocity().Length(), Math.abs(bodyB.GetAngularVelocity()));
                // let impactAngle = (velocityA > velocityB) ? Math.atan2(bodyA.GetLinearVelocity().get_y(), bodyA.GetLinearVelocity().get_x()) : Math.atan2(bodyB.GetLinearVelocity().get_y(), bodyB.GetLinearVelocity().get_x());
                // impactAngle *= game.editor.RAD2DEG + 180;

                const fastestBody = velocityA > velocityB ? bodyA : bodyB;

                const velocitySum = velocityA + velocityB;

                let allowSound = true;
                if(bodyA.recentlyImpactedBodies && bodyA.recentlyImpactedBodies.includes(bodyB)) allowSound = false;
                if(bodyB.recentlyImpactedBodies && bodyB.recentlyImpactedBodies.includes(bodyA)) allowSound = false;

                if (velocitySum > 10.0 && force > 10 * fastestBody.GetMass() && allowSound) {
                    let targetSounds = ['impact-small1', 'impact-small2'];

                    if(!bodyA.recentlyImpactedBodies) bodyA.recentlyImpactedBodies = [];
                    bodyA.recentlyImpactedBodies.push(bodyB);

                    if(fastestBody.GetMass() > 1000) targetSounds = ['impact-heavy1', 'impact-heavy2'];
                    if(fastestBody.GetMass() > 100) targetSounds = ['impact-medium1', 'impact-medium2'];

                    AudioManager.playSFX(targetSounds, 0.1, 1.4 + 0.4 * Math.random()-0.2, fastestBody.GetPosition());
                }
            }
        }
    }

    let then, now;
    this.gameRender = (newtime) => {
        if (!then) then = window.performance.now();
        requestAnimationFrame(self.gameRender);
        now = newtime;
        const elapsed = now - then;
        if (elapsed > Settings.timeStep) {
            then = now - (elapsed % Settings.timeStep);
            const hold = holdFrame() && multiplayerState.lobbyState === LOBBY_STATE.OFFLINE;
            const updates = hold ? 0 : ReplayManager.updatesThisFrame();
            for(let i = 1; i <= updates; i++) self.gameUpdate(i === updates);
            if(hold) drawHeldFrame();
            replayControls.update();
        }
    }

    this.gameUpdate = function (render = true) {

        this.stats.begin();
        const inputFocused = !document.hidden && document.hasFocus() && [document.body, this.canvas].includes(document.activeElement);
        menuNavigation.refresh();
        input.update({enabled: inputFocused && !menuNavigation.active});
        // Gamepad input has no DOM event, including while navigating a menu.
        if(!document.hidden && document.hasFocus() && !input.blocked && input.previousPadInputs.size) {
            this.gameplaySession.interact();
        }
        const replaying = ReplayManager.isReplaying();
        if(input.down.size && !replaying) this.levelSession.interact();
        this.levelSession.update(!replaying && this.run && !this.pause && !this.gameOver && !this.levelWon && this.gameState === this.GAMESTATE_NORMALPLAY);
        menuNavigation.updateGamepad(input.gamepad, {enabled: !document.hidden && document.hasFocus()});
        if(inputFocused && !input.blocked && !menuNavigation.active && !replaying) {
            for(const action of input.padPressed) {
                if(this.handleInputAction(action)) break;
            }
        }


        if (Settings.allowMouseMovement && this.mouseJoint) {
            if (Key.isDown(Key.MOUSE)) {
                this.mouseJoint.SetTarget(new b2Vec2(this.editor.mousePosWorld.get_x(), this.editor.mousePosWorld.get_y()));
            } else {
                this.editor.DestroyJoint(this.mouseJoint);
                this.mouseJoint = null;
            }
        }


        this.stats.begin('physics', '#ecbc4d');
        if (this.run && ReplayManager.beginFrame(this)) {
            PhysicsParticleEmitter.beginFrame();

            this.inputUpdate();
            this.world.Step(Settings.physicsTimeStep * game.editor.editorSettingsObject.gameSpeed, 8, 6);
            this.gameFrame++;
            this.world.ClearForces();
            this.gameCamera();
            PhysicsParticleEmitter.update();
            GameTimer.update();
        }

        updateBackground();

        this.stats.end('physics');

        EffectsComposer.update();
        SlowmoUI.update();
        this.editor.run();
        if(this.run && !this.pause){
            BreakableManager.update();
            ExplosionManager.update();
        }
        // Prefabs update moving emitter anchors in editor.run(), and explosions
        // can create emitters above. Simulate particles only after both so a
        // spray begins at this frame's wound/impact position, not last frame's.
        emitterManager.update();
        ExplosionEffects.update();
        AudioManager.update();

        // Clearing an empty Graphics still invalidates Pixi's render group and
        // rebuilds all world batches. Only clear when there is something drawn.
        if(this.newDebugGraphics.context.instructions.length) this.newDebugGraphics.clear();
        b2DebugDrawManager.clear();
        if ((this.gameState == this.GAMESTATE_EDITOR || Settings.admin) && this.editor.editorSettingsObject.physicsDebug) {
            b2DebugDrawManager.update(this.editor.cameraHolder.x / Settings.PTM, this.editor.cameraHolder.y / Settings.PTM);
        }

        // move our trigger debug draw
        this.triggerDebugDraw.x = this.editor.cameraHolder.x;
        this.triggerDebugDraw.y = this.editor.cameraHolder.y;
        this.triggerDebugDraw.scale.x = this.editor.cameraHolder.scale.x;
        this.triggerDebugDraw.scale.y = this.editor.cameraHolder.scale.y;

        this.stats.begin('render', '#4399fa');
        const rendered = render && (!Settings.FPSLimiter || (Settings.FPSLimiter && !Settings.FPSFrameLimit));
        if(rendered) this.app.render();
        Settings.FPSFrameLimit = !Settings.FPSFrameLimit;
        this.stats.end('render');

        // the drawing buffer is only readable in the frame that rendered it
        if(this.needScreenshot && rendered) this.screenShotData = this.copyScreen();
        PIXICuller.update();

        updateMultiplayer();
        updateMultiplayerHud();

        Key.update();

        this.stats.end();
    };

    this.copyScreen = function () {
        const screenCanvas = document.createElement('canvas');
        screenCanvas.width = this.app.canvas.width;
        screenCanvas.height = this.app.canvas.height;
        screenCanvas.getContext('2d').drawImage(this.app.canvas, 0, 0);
        return screenCanvas;
    };

    this.voteLevel = function(levelData, vote){

        if(!backendManager.isLoggedIn()){
            game.ui.showLoginPrompt();
            return Promise.reject();
        }

        // have i even played this level?  //return Promise.reject()
        return backendManager.voteLevel(levelData.id, vote);
    }

    this.prepareGameFonts = function () {
        const container = document.createElement('div');
        document.body.appendChild(container);
        for (let i = 0; i < Settings.availableFonts.length; i++) {
            const el = document.createElement('p');
            el.style.fontFamily = Settings.availableFonts[i];
            el.style.fontSize = "0px";
            el.style.visibility = "hidden";
            el.innerHTML = '.';
            container.appendChild(el);
        }
        setTimeout(() => {
            container.remove()
        }, 5000);
    }

    this.toggleMute = function(){
        const userData = SaveManager.getLocalUserdata();
        userData.sfxOn = !userData.sfxOn;
        SaveManager.updateLocalUserData(userData);

        Settings.sfxOn = userData.sfxOn;

        if(!Settings.sfxOn){
            AudioManager.stopAllSounds();
        }
    }


    this.GAMESTATE_MENU = 0;
    this.GAMESTATE_EDITOR = 1;
    this.GAMESTATE_NORMALPLAY = 2;
    this.GAMESTATE_LOADINGDATA = 3;
    this.GAMESTATE_LOBBY = 4;
    this.GAMESTATE_MULTIPLAYER_LEVELSELECT = 5;
    this.GAMESTATE_MULTIPLAYERPLAY = 6;
}
export var game = new Game();
if (import.meta.env.DEV) {
    // Expose the active game to local AI/debug sessions only.
    window.game = game;
    window.menuNavigation = menuNavigation;
}
setTimeout(() => {
    const font = new FontFaceObserver('Montserrat');
    font.load().then(() => {
        game.gameInit();
    }).catch(err => {
        game.gameInit();
    });
}, 1); // guarantee all context is loaded and fix webpack order issue
